import Link from "next/link";
import * as React from "react";
import styles from "./styles.module.css";
import { Button } from "@/components/Shared";
import VehicleRegForm from "@/components/Insurance/VehicleRegForm";

const InsuranceHeaderContent: React.FC<{
	title: string;
	landing?: boolean;
	insuranceLink?: string;
	listItems: Array<string>;
	vehicleReg?: boolean;
	bottomHeader?: boolean;
	disclaimerText?: string;
	onClick?: () => void;
}> = ({
	title,
	listItems,
	landing = false,
	insuranceLink,
	vehicleReg = false,
	bottomHeader = false,
	disclaimerText,
	onClick,
}) => {
	const scrollToInsuranceCards = () => {
		const element = document.getElementById("insurance-cards");
		element?.scrollIntoView({ behavior: "smooth" });
	};

	const list = listItems.map((item: string, index: number) => (
		<li key={index}>
			<span>&#x2713; </span> {item}
		</li>
	));

	return (
		<div className={`${styles.hero} mx-0 `}>
			{bottomHeader ? (
				<h2 className={styles.hero__title}>{title}</h2>
			) : (
				<h1 className={styles.hero__title}>{title}</h1>
			)}

			<div className={`${styles.hero__text}`}>
				<ul style={{ listStyle: "none", padding: "0" }}>{list}</ul>
			</div>

			{landing ? (
				<div
					style={{
						maxWidth: "300px",
						paddingTop: "10px",
						margin: bottomHeader ? "auto" : "",
					}}
					className={bottomHeader ? "" : "mx-auto ms-md-0"}
				>
					<Button
						type="button"
						name="Choose type of insurance"
						title="Choose type of insurance"
						onClick={() => scrollToInsuranceCards()}
					/>
				</div>
			) : vehicleReg ? (
				<VehicleRegForm insuranceLink={insuranceLink} onClick={onClick} />
			) : (
				<div
					style={{
						maxWidth: "300px",
						paddingTop: "10px",
						margin: bottomHeader ? "auto" : "",
					}}
					className={bottomHeader ? "" : "mx-auto ms-md-0"}
				>
					<Link
						onClick={onClick}
						href={insuranceLink ?? ""}
						className="text-decoration-none"
					>
						<Button type="button" name="Get Quotes" title="Get Quotes" />
					</Link>
				</div>
			)}
			{bottomHeader ? (
				<div className="mt-5 w-100 mx-auto">
					<p>
						<small className="text-muted">
							The information contained within this webpage is for editorial
							purposes only and not intended as financial advice.
						</small>
						<br />
						<small className="text-muted">
							Savely Financial Services Limited is an introducer-appointed
							representative (IAR) of Seopa Limited, which is authorised and
							regulated by the Financial Conduct Authority (FCA FRN 313860).
						</small>
						<br />
						<small className="text-muted">{disclaimerText}</small>
					</p>
				</div>
			) : (
				<></>
			)}
		</div>
	);
};

export default InsuranceHeaderContent;
